import styled from '@emotion/styled';
import { spacing } from '@naf/theme';

export const ShortcutsContainer = styled.div`
  margin-top: 0;

  h2 {
    margin-bottom: ${spacing.space24};
  }
`;
